/**
 * Files API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { FileUpload, FileRecord } from '@repo/shared-types';
import { apiTransport as router } from './transport';
import { getContext } from './core';

export const filesApi = {
  upload: async (upload: FileUpload) => {
    const context = getContext();
    // Simplified upload in simulation
    return router.post<FileRecord>('/files', upload, context);
  },
  get: async (id: string) => router.get<FileRecord>(`/files/${id}`),
  list: async (filters?: { entityType?: FileRecord['entityType']; entityId?: string }) => {
    let query = '';
    if (filters?.entityType) query = `?entityType=${filters.entityType}`;
    if (filters?.entityId) query = (query ? `${query}&` : '?') + `entityId=${filters.entityId}`;
    return router.get<FileRecord[]>(`/files${query}`);
  },
  delete: async (id: string) => {
    const context = getContext();
    return router.delete<{ success: boolean }>(`/files/${id}`, context);
  },
  download: async (id: string) => {
    // In simulation, we just return the file record url or success
    const file = await router.get<FileRecord>(`/files/${id}`);
    if (!file) throw new Error('File not found');
    return file;
  }
};

